type AnyObject = { [key: string]: any };

export const omitNullableAndUndefinedFields = <T extends AnyObject>(obj: T): T => {
  const result = {} as T;

  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined) {
      result[key] = obj[key];
    }
  }

  return result;
};

export const isNullUUID = (id: string): boolean => id === "00000000-0000-0000-0000-000000000000";
